import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';
import { schemas } from '@convergence/client';

export function useAnalysisQuery(slug: string) {
  const q = useQuery({
    queryKey: ['analysis', slug],
    queryFn: async () => {
      const data = await fetch(
        `/analysis/${slug}`,
        { method: 'GET' },
        schemas.AnalysisDto
      );
      return data;
    },
    retry: false,
    refetchInterval: 5000
  });

  return q;
}
